import { render, staticRenderFns } from "./SurrogatePerLocation.vue?vue&type=template&id=6e5cc842&"
import script from "./SurrogatePerLocation.vue?vue&type=script&lang=js&"
export * from "./SurrogatePerLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports